export default __webpack_public_path__ + "static/media/reset.c17fcf5c.svg";